import {
  N0SsrPassengerUpdateRequest,
  N0SsrUpdate,
} from '@models/requests/ssr-passenger-update-request.model';
import { createAction, props } from '@ngrx/store';
import { Booking } from "@models/booking.models";
import {SellBundleRequest} from "@models/requests/sell-bundle-request.model";

export const enum ExtrasActionTypes {
  storeExtrasUpdateRequest = '[extras] STORE_EXTRAS_UPDATE_REQUEST',
  storeExtrasUpdateRequestAllPax = '[extras] STORE_EXTRAS_UPDATE_REQUEST_ALL_PAX',
  sellExtrasSsrs = '[extras] SELL_EXTRAS_SSRS',
  sellExtrasSsrsSuccess = '[extras] SELL_EXTRAS_SSRS_SUCCESS',
  validateExtrasSelection = '[extras] VALIDATE_EXTRAS_SELECTION',
  clearTotalSelectionsState = '[extras] CLEAR_TOTAL_SELECTION_STATE',
  sellExtrasBundle = '[extras] SELL_EXTRAS_BUNDLE',
  sellExtrasBundleSuccess = '[extras] SELL_EXTRAS_BUNDLE_SUCCESS',
  removeExtrasBundle = '[extras] REMOVE_EXTRAS_BUNDLE',
}

export const extrasStoreExtrasUpdateRequest = createAction(
  ExtrasActionTypes.storeExtrasUpdateRequest,
  props<{ payload: N0SsrPassengerUpdateRequest }>(),
);

export const extrasStoreExtrasUpdateRequestAllPax = createAction(
  ExtrasActionTypes.storeExtrasUpdateRequestAllPax,
  props<{ journeyKey: string; ssr: N0SsrUpdate }>(),
);

export const extrasSellExtrasSsrs = createAction(
  ExtrasActionTypes.sellExtrasSsrs,
  (payload: {redirectToPayment: boolean} = {redirectToPayment: true}) => payload,
);

export const extrasSellExtrasSsrsSuccess = createAction(
  ExtrasActionTypes.sellExtrasSsrsSuccess,
  props<{ redirectToPayment: boolean }>(),
);

export const extrasValidateExtrasSelection = createAction(
  ExtrasActionTypes.validateExtrasSelection,
);

export const extrasClearTotalSelectionsState = createAction(
  ExtrasActionTypes.clearTotalSelectionsState,
);

export const extrasSellExtrasBundle = createAction(
  ExtrasActionTypes.sellExtrasBundle,
);

export const extrasRemoveExtrasBundle = createAction(
  ExtrasActionTypes.removeExtrasBundle,
);

export const extrasSellExtrasBundleSuccess = createAction(
  ExtrasActionTypes.sellExtrasBundleSuccess,
  props<{ payload: Booking, request: SellBundleRequest }>(),
);
